<form [formGroup]="searchForm" [style.width]="width()">
  <lib-input
    [inputFormControlName]="'search'"
    [id]="'search'"
    [type]="'text'"
    [name]="'search'"
    [placeholder]="placeholder()"
    [startIconTemplate]="startIcon"
    [endIconTemplate]="endIcon"
    (endIconCLick)="clear()"
    [showEndIconWhenInputHasValue]="true" />
</form>

<ng-template #startIcon>
  <lib-search-icon [iconClass]="'size-5 text-neutral-500'" />
</ng-template>

<ng-template #endIcon>
  <lib-tag-cross-icon [iconClass]="'size-5 text-neutral-500'" />
</ng-template>
